import { useState } from 'react';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: 'Necesitábamos vaciar el piso de mi madre en Mollet del Vallès tras su fallecimiento. El equipo de JUSTCLEAN fue increíblemente profesional y respetuoso. Hicieron todo el trabajo en dos días y dejaron el piso impecable. Muy recomendable.',
      name: 'María González',
      location: 'Mollet del Vallès',
      service: 'Vaciado de piso',
      rating: 5,
    },
    {
      text: 'Contraté sus servicios para un caso de síndrome de Diógenes en un piso de Parets del Vallès. La discreción y profesionalidad fueron excepcionales. Entendieron perfectamente la situación y trabajaron con mucha sensibilidad. Excelente servicio.',
      name: 'Carlos Martínez',
      location: 'Parets del Vallès',
      service: 'Limpieza Diógenes',
      rating: 5,
    },
    {
      text: 'Vaciaron nuestro local comercial en Granollers en tiempo récord. Retiraron todos los muebles, limpiaron a fondo y gestionaron todos los residuos. Precio justo y trabajo impecable. Sin duda los volveré a contratar.',
      name: 'Laura Sánchez',
      location: 'Granollers',
      service: 'Vaciado de local',
      rating: 5,
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Lo que dicen nuestros clientes
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto"></div>
          <p className="mt-6 text-lg text-gray-700 max-w-3xl mx-auto">
            La satisfacción de nuestros clientes en Mollet del Vallès y comarca es nuestra mejor carta de presentación. Lee lo que opinan sobre nuestros servicios de vaciado y limpieza.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-secondary/8 rounded-2xl p-8 md:p-12 relative">
            <div className="absolute top-8 left-8 text-primary/20 text-8xl font-serif leading-none">
              "
            </div>

            <div className="relative z-10">
              <p className="text-dark text-lg md:text-xl italic leading-relaxed mb-8">
                {testimonials[currentIndex].text}
              </p>

              <div className="border-t border-gray-200 pt-6">
                <div className="flex items-center space-x-4">
                  <div className="w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center text-xl font-bold border-2 border-primary">
                    {testimonials[currentIndex].name.charAt(0)}
                  </div>

                  <div className="flex-1">
                    <h4 className="font-bold text-dark text-lg">
                      {testimonials[currentIndex].name}
                    </h4>
                    <p className="text-gray-600 text-sm">
                      {testimonials[currentIndex].location} • {testimonials[currentIndex].service}
                    </p>
                  </div>

                  <div className="flex space-x-1">
                    {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary text-lg"></i>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center space-x-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 rounded-full bg-dark text-white flex items-center justify-center hover:bg-primary transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>

            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-200 cursor-pointer ${
                    index === currentIndex ? 'bg-primary w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 rounded-full bg-dark text-white flex items-center justify-center hover:bg-primary transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;